<template>
    <div id="header" :class="['header', 'main-header']">
        <div class="top_inner01">
            <div id="header-inner-top">
                <div class="top-logo" style="z-index: 100;">
                    <a :href="$_WC.cp + 'main'">
                        <img :src="logoImg" v-show="logoImg !== ''" class="header-logo-img" alt="top-logo" />
                    </a>
                </div>
                <div class="main-tit pdt-10" @click.prevent="goMain()">
                    <!-- <h2>스마트강남 열린 구청장실 <p>모든 행정데이터를 한눈에</p></h2> -->
                    <h2>
                        <img src="@/assets/images/common/logo2.png" alt="데이터 강남 플랫폼">
                    </h2>
                </div>
                <div class="top-r">
                    <div class="weather">
                        <span class="w_icon">
                            <img :src="weatherImg" alt="" />
                        </span>
                        <span class="w_temp">{{ airSpace.t1hValue }}c</span>
                    </div>
                    <a class="goto-menu menu-btn" href="javascript: void(0);">메뉴열기</a>
                </div>
            </div>
            <Search v-if="href.indexOf('/main') > -1 && $_WC.viewScale < 2" />
            <DigitalClock v-if="$_WC.viewScale === 2" />
        </div>

        <div class="top_gnb pc-visible d4k-hidden">
            <div class="top_inner02">
                <!-- <ul class="menu01">
                    <li><a :href="$_WC.cp + 'main'"><b>홈</b></a></li>
                    <li><a :href="$_WC.cp + 'realtime'"><b>실시간 도시 현황</b></a></li>
                    <li><a :href="$_WC.cp + 'biz'"><b>미래를 그리는 강남</b></a></li> -->
                    <!-- <li><a :href="$_WC.cp + 'biz?selectedTab=policy'"><b>정책 강남</b></a></li> -->
                    <!-- <li><a :href="$_WC.cp + 'lifemap'"><b>강남 Maps</b></a></li>
                    <li><a :href="$_WC.cp + 'indicator'"><b>분야별 지표</b></a></li> -->
                    <!-- <li><a href="javascript:void(0)" @click.prevent="openSeoulRtd()"><b>도시데이터</b></a></li> -->
                    <!-- <li><a :href="$_WC.cp + 'news'"><b>강남 브리핑</b></a></li>
                    <li><a :href="$_WC.cp + 'read'"><b>데이터로 분석한 구정</b></a></li>
                    <li><a :href="$_WC.cp + 'openapi'"><b>공공데이터</b></a></li>
                    <li><a :href="$_WC.cp + 'intro'"><b>시스템 소개</b></a></li>
                </ul> -->
                <ul class="menu01">
                    <template v-for="menu in this.menuList" >
                        <li v-if="menu.menuNm !== '메타강남'" :key="menu.menuSeq">
                            <a :href="$_WC.cp + menu.menuUrl"><b>{{ menu.menuNm }}</b></a>
                        </li>
                    </template>
                </ul>
            </div>
        </div>

        <div class="top_gnb d4k-visible">
            <div class="top_inner02">
                <!-- <ul class="menu01">
                    <li><a :href="$_WC.cp + 'main'"><b>홈</b></a></li>
                    <li><a :href="$_WC.cp + 'news'"><b>강남 브리핑</b></a></li>
                    <li><a :href="$_WC.cp + 'realtime'"><b>실시간 도시 현황</b></a></li>
                    <li><a :href="$_WC.cp + 'biz'"><b>미래를 그리는 강남</b></a></li> -->
                    <!-- <li><a :href="$_WC.cp + 'biz?selectedTab=policy'"><b>정책 강남</b></a></li> -->
                    <!-- <li><a :href="$_WC.cp + 'lifemap'"><b>강남 Maps</b></a></li>
                    <li><a :href="$_WC.cp + 'indicator'"><b>분야별 지표</b></a></li> -->
                    <!-- <li><a href="javascript:void(0)" @click.prevent="openSeoulRtd()"><b>도시데이터</b></a></li> -->
                    <!-- <li><a :href="$_WC.cp + 'read'"><b>데이터로 분석한 구정</b></a></li>
                    <li><a :href="$_WC.cp + 'welcome'"><b>웰컴보드</b></a></li>
                    <li><a :href="$_WC.cp + 'intro'"><b>시스템 소개</b></a></li>
                </ul> -->
                <ul class="menu01">
                    <li v-for="menu in this.fixed4kMenuList" :key="menu.menuSeq">
                        <a :href="$_WC.cp + menu.menuUrl"><b>{{ menu.menuNm }}</b></a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Search from '@/views/common/Search.vue';
import DigitalClock from "@/views/common/DigitalClock";
import { $_WC, $_TYPE } from '@/confs/common.const.js';
import commonConstMixin from "@/stores/common.const.mixin.js"
import {mapGetters} from "vuex";

export default {
    name: 'LayoutHeader',
    components: {
        DigitalClock,
        Search,
    },
    data(){
        return {
            href: window.location.href,
            menuList: this.$session.get('menuList'),
            upperMenu: this.$session.get('upperMenu'),
            mainMenu: this.$session.get('mainMenu'),
        }
    },
    created() {
        this.$store.dispatch('FETCH_LOGO_FILE');

        this.$store.dispatch('FETCH_AIRSPACE');
        setInterval(()=>{
            this.$store.dispatch('FETCH_AIRSPACE');
        }, 1000 * 60 * 10);
    },
    computed: {
        ...mapGetters({
            logoFile: 'getLogoFile',
            airSpace: 'getAirSpace',
        }),
        logoImg() {
            if(typeof this.logoFile.val2 !== $_TYPE.UNDEF) {
                return this.logoFile.val2;
            }
            return '';
        },
        weatherImg(){
            if(typeof this.airSpace.skyValue !== $_TYPE.UNDEF) {
                return $_WC.assets + 'img/spaceSkyCd.' + this.airSpace.skyValue + '.png';
            }
            return '';
        },
        fixed4kMenuList() {
            let newList = [];
            if(typeof this.menuList !== $_TYPE.UNDEF) {
                newList = JSON.parse(JSON.stringify(this.menuList));
                // console.log('newList', newList);
                // 9.30까지는 해당 메뉴 표출
                // newList = newList.filter(d => {
                //     // 4k의 경우 공공데이터 메뉴 표출 하지 않음.
                //     return d.menuUrl !== 'openapi';
                // });
                let muneWelcome = {
                    menuSeq : -255,
                    systemSe : 'D',
                    upperMenuSeq : -100,
                    menuNm : '웰컴보드',
                    menuUrl : 'welcome',
                    sortOrder : 26,
                    menuSe : 'S',
                    updt : '',
                    empNo : null,
                    menuDsc	: null,
                    selected : false,
                    subPageMenus : null,
                }
                // 4k의 경우 웰컴보드를 시스템소개 앞으로 배치
                let lastmap = newList.pop();
                newList.push(muneWelcome);
                newList.push(lastmap);
                // console.log('newList', newList);
            }
            return newList;
        },
    },
    methods: {
        goMain(){
            location.href = $_WC.cp + 'main';
        },
        openSeoulRtd() {
            let width = '1920';
            let height = '1080';
            let options = "toolbar=no,scrollbars=no,resizable=yes,status=no,menubar=no,width=" + width + ", height=" + height + ", top=0,left=0";
            window.open('https://data.seoul.go.kr/SeoulRtd/', '_blank', options);
        },
    },
    mixins: [commonConstMixin],
}
</script>
<style>
.header-logo-img {
    width: inherit;
    height: inherit;
    border-radius: 8px;
}
.main-tit {
    z-index: 1;
    width:30%;
    cursor: pointer;
}
@media (min-width:0) and (max-width:768px) {
    .main-tit {
        width:50%;
    }
    .header-logo-img {
        width: 100% !important;
        height: 51% !important;
    }
}
@media (min-width: 1500px) {
    .header-logo-img {
        width: 150px !important;
        height: 39px !important;
        margin-top: 1px;
    }
}
@media (min-width: 2737px) and (max-width: 7680px) {
    .header-logo-img {
        width: 488px !important;
        height: 140px !important;
        margin-top: -16px;
        border-radius: 20px;
    }
}
</style>
